export const CHANGE_INPUT_VALUE = 'change_input_value';